import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">探索当前最受关注的51大赛话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic, index) => (
            <div
              key={index}
              className={`group flex items-center gap-2.5 px-4 py-2.5 rounded-full ${topic.color} cursor-pointer transition-all duration-200 hover:scale-105`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-xs opacity-60 font-medium">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}